import { render, staticRenderFns } from "./thumb-bar.vue?vue&type=template&id=29aa606b&scoped=true"
import script from "./thumb-bar.vue?vue&type=script&lang=js"
export * from "./thumb-bar.vue?vue&type=script&lang=js"
import style0 from "./thumb-bar.vue?vue&type=style&index=0&id=29aa606b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa606b",
  null
  
)

export default component.exports